module.exports = function floor(value) {
  //  discuss at: https://locutus.io/php/floor/
  // original by: Onno Marsman (https://twitter.com/onnomarsman)
  //   example 1: floor(8723321.4)
  //   returns 1: 8723321

  return Math.floor(value)
}
